import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProOfferDirectForm } from '@/components/modules/pages/rfp/professional/Form/RfpProOfferForm/RfpProOfferDirectForm';
import { RfpProOfferPublicForm } from '@/components/modules/pages/rfp/professional/Form/RfpProOfferForm/RfpProOfferPublicForm';
import { splitInterviewSchedule } from '@/utils/resources/rfp/rfpInterviewSchedule';
import { isRfpTypeDirectOffer } from '@/utils/resources/rfp/rfpType';
/**
 * コンサルタント案件提出 Form 切り替え
 */
export const RfpProOfferForm = (props) => {
    const { className = '', hasUploadingFile, id, initialValues, interviewSchedule, lockId, onClickAddMember, onSubmit, rfpType, uploadFile, } = props;
    const isDirect = isRfpTypeDirectOffer(rfpType);
    /** 面談予定日（表示用の文字列） */
    const interviewScheduleText = useMemo(() => splitInterviewSchedule(interviewSchedule).join('、'), [interviewSchedule]);
    // RFI/業務委託 Form
    if (isDirect) {
        return (_jsx(RfpProOfferDirectForm, { className: className, hasUploadingFile: hasUploadingFile, id: id, initialValues: initialValues, interviewSchedule: interviewScheduleText, lockId: lockId, onClickAddMember: onClickAddMember, onSubmit: onSubmit, uploadFile: uploadFile }));
    }
    // 公募 Form
    return (_jsx(RfpProOfferPublicForm, { className: className, hasUploadingFile: hasUploadingFile, id: id, initialValues: initialValues, interviewSchedule: interviewScheduleText, lockId: lockId, onClickAddMember: onClickAddMember, onSubmit: onSubmit, uploadFile: uploadFile }));
};
